import type { ThreadCategory } from '@/lib/api';
// Mirrors backend/internal/domain/thread_category.go's categoryStarters
// map -- issue #266. Kept as plain data (no tamagui import) so it can be
// imported from anywhere, same reasoning as lib/prompt-bank.ts.
export const THREAD_CATEGORIES: { value: ThreadCategory; label: string; starter: string }[] = [
  { value: 'local', label: 'Local', starter: 'Anyone know a good...' },
  { value: 'hobby', label: 'Hobby', starter: 'Looking for people into...' },
  { value: 'pet_peeve', label: 'Pet Peeve', starter: 'Does anyone else find it annoying when...' },
  { value: 'meetup', label: 'Meetup', starter: 'Meetup: ' },
  { value: 'recommendation', label: 'Recommendation', starter: 'Can anyone recommend a...' },
  { value: 'review', label: 'Review', starter: 'My take on...' },
  { value: 'chat', label: 'Chat', starter: 'Just want to chat about...' },
];

// Validates a `category` route param (the Threads filter carried into the
// composer, issue #411); anything unrecognised means "no preselection".
export function categoryFromParam(param: string | string[] | undefined): ThreadCategory | undefined {
  const raw = Array.isArray(param) ? param[0] : param;

  return THREAD_CATEGORIES.find((c) => c.value === raw)?.value;
}

export function categoryLabel(category: ThreadCategory): string {
  return THREAD_CATEGORIES.find((c) => c.value === category)?.label ?? category;
}
